import {
  SearchAITGroupMasterRequest,
  DetailAITGroupMasterRequest,
  UpdateAITGroupMasterRequest,
  DeleteAITGroupMasterRequest,
  DetailAITGroupMasterResponse,
  SearchAITGroupMasterRecord,
  SearchAITGroupMasterResponse,
} from 'api-types/src/types/ait-group-master';
import { createSlice } from '@reduxjs/toolkit';
import i18n from 'i18n/i18n';

type AitGrMasterState = {
  loading: boolean;
  loadingExportExcel: boolean;
  filterSearchTotal: number;
  filterInitialSearchData: SearchAITGroupMasterRecord[];
  filterSearchData: SearchAITGroupMasterRecord[];
  sortSelected: string;
  sortDirection: string;
  message: string;
  aitGrDetail: DetailAITGroupMasterResponse | {};
  success: boolean;
};

const initialState: AitGrMasterState = {
  loading: false,
  loadingExportExcel: false,
  filterSearchTotal: 0,
  filterInitialSearchData: [],
  filterSearchData: [],
  sortSelected: '',
  sortDirection: '',
  message: '',
  aitGrDetail: {},
  success: false,
};

export const aitGrMasterSlice = createSlice({
  name: 'aitGrMaster',
  initialState,
  reducers: {
    filterAitGr: (state, action: { payload: SearchAITGroupMasterRequest }) => {
      state.loading = true;
      state.message = '';
    },
    filterAitGrSuccess: (state, action: { payload: SearchAITGroupMasterResponse }) => {
      state.loading = false;
      state.filterSearchData = action.payload?.records;
      if (!action.payload?.total) {
        state.message = i18n.t('message.common.0001');
      }
      state.filterSearchTotal = action.payload?.total;
      state.success = false;
    },
    filterAitGrFailure: (state) => {
      state.loading = false;
    },
    filterAitGrDrop: (state, action: { payload: SearchAITGroupMasterRequest }) => {
      state.loading = true;
      state.message = '';
    },
    filterAitGrDropSuccess: (state, action: { payload: SearchAITGroupMasterResponse }) => {
      state.loading = false;
      state.filterInitialSearchData = action.payload?.records;
      state.success = false;
    },
    getDetailAitGr: (state, action: { payload: DetailAITGroupMasterRequest }) => {
      state.loading = true;
    },
    getDetailAitGrSuccess: (state, action: { payload: DetailAITGroupMasterResponse }) => {
      state.loading = false;
      state.aitGrDetail = action.payload;
    },
    getDetailAitGrFailure: (state, action) => {
      state.loading = false;
      state.message = action.payload?.message;
    },
    setLoadingExportExcel: (state, action) => {
      state.loadingExportExcel = action.payload;
    },
    registerAitGr: (state, action: { payload: UpdateAITGroupMasterRequest }) => {
      state.loading = true;
      state.success = false;
    },
    registerAitGrSuccess: (state, action) => {
      state.loading = false;
      state.success = true;
      state.message = action.payload?.message;
    },
    registerAitGrFailure: (state, action) => {
      state.loading = false;
      state.success = false;
      state.message = action.payload?.message;
    },
    deleteAitGr: (state, action: { payload: DeleteAITGroupMasterRequest }) => {
      state.loading = true;
      state.success = false;
    },
    deleteAitGrSuccess: (state, action) => {
      state.loading = false;
      state.success = true;
      state.message = action.payload?.message;
    },
    deleteAitGrFailure: (state, action) => {
      state.loading = false;
      state.success = false;
      state.message = action.payload.message;
    },
    cleanDataAitGr: (state) => {
      state.aitGrDetail = {};
    },
    cleanData: (state) => {
      return {
        ...initialState,
      };
    },
  },
});

export const {
  filterAitGr,
  filterAitGrSuccess,
  filterAitGrFailure,
  filterAitGrDrop,
  filterAitGrDropSuccess,
  setLoadingExportExcel,
  getDetailAitGr,
  getDetailAitGrSuccess,
  getDetailAitGrFailure,
  registerAitGr,
  registerAitGrSuccess,
  registerAitGrFailure,
  deleteAitGr,
  deleteAitGrSuccess,
  deleteAitGrFailure,
  cleanDataAitGr,
  cleanData,
} = aitGrMasterSlice.actions;

export default aitGrMasterSlice.reducer;
